import React from 'react';
import Routes from './routes/routes';
import './styles.scss'


const App = () => <Routes />

export default App;
